<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineScheduleConfirmSection',
})

defineProps<{
  title: string
  items: string[]
}>()
</script>

<template>
  <div class="discipline-schedule-confirm-section">
    <AppText name="body1-medium">
      {{ title }}
    </AppText>
    <div class="discipline-schedule-confirm-section__items">
      <AppText
        v-for="item in items"
        :key="item"
        name="body1"
        color="slate-700"
      >
        {{ item }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleConfirmSection.scss" />
